/* CERA — before/after slider. Used by the before/after section and, when it
   is turned on, by a slide inside the PDP gallery. Dragging is handled on the
   frame with pointer capture so it tracks from the first pixel of movement;
   the range input stays behind it and carries the keyboard. */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  $$('[data-cera-ba]').forEach(function (view) {
    var range = $('[data-cera-ba-range]', view);
    if (!range) return;

    var pending = null;
    var frame = 0;

    // Painting is batched into one frame so a fast drag never queues more
    // repaints than the browser can serve — that backlog is what makes a
    // clip-path slider feel like it lags behind the finger.
    function paint() {
      frame = 0;
      view.style.setProperty('--p', pending + '%');
      range.value = pending;
    }

    function set(x) {
      pending = Math.max(0, Math.min(100, x));
      if (!frame) frame = requestAnimationFrame(paint);
    }

    function fromEvent(e) {
      var box = view.getBoundingClientRect();
      if (!box.width) return;
      set(((e.clientX - box.left) / box.width) * 100);
    }

    // Drag the whole surface rather than the hidden range input: pointer
    // capture follows the cursor outside the box and reacts on the first
    // pixel of movement, with no thumb to grab first.
    var dragging = false;

    view.addEventListener('pointerdown', function (e) {
      if (e.button != null && e.button !== 0) return;
      dragging = true;
      stopIntro();
      view.setPointerCapture(e.pointerId);
      fromEvent(e);
    });

    view.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      fromEvent(e);
    });

    function release(e) {
      if (!dragging) return;
      dragging = false;
      if (view.hasPointerCapture(e.pointerId)) view.releasePointerCapture(e.pointerId);
    }
    view.addEventListener('pointerup', release);
    view.addEventListener('pointercancel', release);

    // The range stays for the keyboard, and is the only thing that moves it
    // when pointer events are unavailable.
    range.addEventListener('input', function () { stopIntro(); set(Number(range.value)); });
    range.addEventListener('keydown', stopIntro);

    set(Number(range.value) || 50);

    /* One gentle sweep the first time it comes into view, so the control
       explains itself without a caption. Any input cancels it — otherwise it
       keeps overwriting the position the visitor just dragged to. */
    var intro = 0;

    function stopIntro() {
      if (intro) cancelAnimationFrame(intro);
      intro = -1;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || intro) return;
        obs.disconnect();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var t0 = performance.now();
        intro = requestAnimationFrame(function step(t) {
          if (intro === -1) return;
          var k = Math.min(1, (t - t0) / 1800);
          set(50 + Math.sin(k * Math.PI * 2) * 22 * (1 - k));
          intro = k < 1 ? requestAnimationFrame(step) : -1;
        });
      });
    }, { threshold: 0.5 });
    io.observe(view);
  });
})();
